import { createFileRoute } from '@tanstack/react-router'
import { z } from '@spcc/core'
import { SearchResultsSection } from '@spcc/domains/global-search'

const searchSchema = z.object({
  q: z.string().optional(),
})

export const Route = createFileRoute('/search')({
  validateSearch: (search) => searchSchema.parse(search),
  component: SearchPage,
})

function SearchPage() {
  const { q } = Route.useSearch()
  return <SearchResultsSection query={q || ''} />
}
